<template>
  <el-col align="left">
    <popup
      button-style="primary"
      heading="New Contact"
      :show-text="showText"
      button-text="Contact"
      :center-button="true"
      :button-size="buttonSize"
      :disable-button="!isManager()"
      button-icon="fa fa-user"
      @save="onSaveDialog"
      @close="onCloseDialog">

        <add-contact-details ref="cd" name="cd" :row-data="contactData" :org-id="org_id"
          :editMode="true" :adding="true" :hide-panel="true" :table-ref="tableRef" />

    </popup>
  </el-col>

</template>


<script>

import Vue from 'vue'

import ContactDetail from '@/components/tables/details/ContactDetail'

Vue.component('add-contact-details', ContactDetail)

export default {

  name: 'ContractAction',

  components: {
    ContactDetail
  },

  props: {
    orgId: {
      type: Number,
      required: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    editMode: {
      type: Boolean,
      default: true
    },
    buttonSize: {
      type: String,
      default: 'small'
    },
    tableRef: {
      type: String,
      default: 'contactstable'
    }
  },

  methods: {

    onSaveDialog () {
      this.$refs.cd.onSave(this.orgId)
    },

    onCloseDialog () {
      this.$refs.cd.onClose()
    }

  },

  computed: {
    org_id: function () {
      return this.orgId
    }
  },

  data () {
    return {
//      org_id: this.orgId,
      editing: this.editMode,
      contactData: this.getTableStruct('contacts')
    }
  }
}

</script>



// WEBPACK FOOTER //
// ContactAction.vue?1e98e32c